
import React, { useState, useContext } from 'react';
import { Button, Spinner, Container, Modal } from 'react-bootstrap';
import styles from './modal-content-upload-orders.module.scss';
import FileDropZone from '../../../../../components/FileDropZone';
import { SecurityContext } from "../../../../../context/security-context";
import closeIcon from "../../../../../assets/close.svg";
import csvIcon from "../../../../../assets/csv.svg";
import SecurityService from "../../../../../services/security-service";
import { OrderFileValidator } from "../../../../../helpr/orderFileValidator" ;
import Loading from '../../../../../components/loading/loading';


const UploadOrdersModalContent = ({security}) => {

  const [ fileState, setFileState ] = useState();
  const [ uploadFlag, setUploadFlag ] = useState();
  const { securityState } = useContext(SecurityContext);
  const [ fileErrors, setFileErrors ] = useState([]);
  const [ validationLoadingFlag, setValidationLoadingFlag ] = useState(false);
  const securityService = new SecurityService();
  const issueOrderListTemplate = 'https://dp-documents-bucket-dev.s3-ap-southeast-1.amazonaws.com/reservation-list-template.csv'

  const formatDate = (dt) => (new Date(dt)).toISOString();

  // Validate File on load
  const fileHandler = (targetFile) => {
    setValidationLoadingFlag(true);

    // Check if file format is valid
    const filenameSegment = targetFile.name.split('.');
    const fileExt = filenameSegment[filenameSegment.length-1];
    if(fileExt.toLowerCase() !== 'csv'){
      setValidationLoadingFlag(false);
      setFileErrors(prev=>[...prev, 'Invalid File Type']);
    }

    const f = targetFile;
    const orderFileValidator = new OrderFileValidator(security);
    const fileReader = new FileReader();
    fileReader.onload = function (event) {
      var contents = event.target.result;
      var lines = contents.split(/\n\r|\r\n|\n|\r/);
      var errors = 0;
      for(let i=1; i<lines.length; i++){
        var validationResult = orderFileValidator.validateRow(lines[i]);
        if(validationResult.valid === false) {
          setFileErrors(prev=>[...prev, validationResult.msg + ' In ROW ' + (i+1)]);
          errors += 1;
          if(errors > 20){ break }
        }
      }
      setValidationLoadingFlag(false);
      setFileState(targetFile);
    }
    fileReader.readAsText(f);
  }

  useState(()=>{
    console.log("ERRORS FOUND");
    setValidationLoadingFlag(false);
  },[fileErrors]);

  const retry = () => {
    setFileErrors([]);
    setFileState(null);
  }

  const renderFileDropZone = () => {
    if (fileErrors.length > 0) {
      return (
        <div className={styles['fileError']}>
          {fileErrors.map((data,)=><div className={styles['msg']}>{data}</div>)}
          <div>
            <span><a className={styles['action']} onClick={()=>retry()}>RETRY</a></span>
          </div>
        </div>
      )
    } else if(fileState == null){
      return <FileDropZone setFileHandler={fileHandler}/>
    } else {
      return (
        <div className={styles['file-detail']}>
          <div className={styles['close-icon']} onClick={()=>removeFile()}>
            <img src={closeIcon}/>
          </div>
          <div className={styles['file-icon']}>
            <img src={csvIcon}/>
          </div>
          <div className={styles['details']}>
            <div>{fileState.name}</div>
            <div>{ formatDate(fileState.lastModified) }</div>
          </div>
        </div>
      )
    }
  }

  const removeFile = () => { setFileState(null); }
  const uploadFile = () => {
    async function service () {
      setUploadFlag(true);
      let result = await securityService.getUploadOrderListPresignedUrl(securityState['securityId'], securityState['applicationId'], securityState['id'], fileState.name, fileState.type);
      console.log(result)
      result = await securityService.uploadOrderListFile(result['presignedUrl'], fileState);
      if(result.status == 200) {
        setFileState(null);
        window.location.reload();
      }
    }
    service();
  }

  return (
    <div className={styles['content']}>
      <div className={styles['security-title']}>
        { securityState['securityName'] }
      </div>
      <div className={styles['instructions']}>
        Upload the order list file below or <a href={issueOrderListTemplate}>Download a template here</a>
      </div>
      <div className={styles['file-upload-area']}>
        { validationLoadingFlag? <Loading/> : renderFileDropZone() }
      </div>
      <div className={styles['instructions']}>
        We warrant that all information contained in this Bulk Reservation Upload is accurate and based
        solely on instructions received from each Client ordering an Application to Purchase to be submitted
        on its behalf by us as its Selling Agent through this electronic facility.  Should the Issuer, its agents,
        and the regulators  so require, any and all evidence of the instructions by the Client-Applicant to
        purchase the Security shall be made available.
      </div>
      <div className={styles['button-container']}>
        <Button className={styles['btn']} disabled={fileState == null || fileErrors.length !== 0} onClick={()=>uploadFile()}>
          { uploadFlag && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"/> }
          Upload
        </Button>
      </div>
    </div>
  )
}

export default UploadOrdersModalContent;
